export const CAPTION_POSITIONS = {
  TOP: "top",
  BOTTOM: "bottom",
  CENTER: "center"
};
